// 交互消息在 chat.js 里的纯逻辑，单独拆出来才能在没有浏览器的情况下测。

// 这些类型的渲染分支看 message.type。reply_to 不能把它们盖成 'reply'，否则带引用的
// 菜单/表单/服务卡实时到达时退化成文本，刷新后（历史接口 type = message_type）才恢复。
const STRUCTURED_TYPES = ['button_group', 'service', 'game', 'markdown', 'card', 'buttons', 'carousel', 'form', 'link', 'embed'];

export function frameDisplayType(frame) {
    const messageType = frame.message_type || 'text';
    if (frame.reply_to && !STRUCTURED_TYPES.includes(messageType)) return 'reply';
    return messageType;
}

function compareById(a, b) {
    const aNum = Number(a.id);
    const bNum = Number(b.id);
    const aValid = a.id != null && Number.isFinite(aNum);
    const bValid = b.id != null && Number.isFinite(bNum);
    if (aValid && bValid) return aNum - bNum;
    if (aValid && !bValid) return -1;
    if (!aValid && bValid) return 1;
    return 0;
}

/**
 * 首屏历史落地。不能直接覆盖 state：加载和 WS 是并行的，历史是请求发出那一刻的快照，
 * 响应回来之前已经实时到达的消息不在快照里。覆盖掉的话它就没了，而 _pacedSeen 已经记过
 * 这个 id，之后的 resync 也不会补回来，只有刷新页面才能再看到。
 *
 * 欢迎流里这件事只发生在按钮菜单上：前面的文本气泡带 typing_ms，还排在队列里没落地，
 * 不受覆盖影响；菜单没有 typing_ms，立刻落地，正好被覆盖。表现就是"文字都在，按钮没了"。
 *
 * 保留规则只看 id：比快照最新一条还新的，一定是快照之后才产生的。客服/flow 的实时帧和
 * 访客自己的 ack 都落在这条规则里。
 *
 * @param current  当前 state.messages
 * @param history  历史接口返回的消息
 */
export function mergeInitialHistory(current, history) {
    const historyIds = new Set(history.map((m) => m.id));
    let newestHistoryId = -Infinity;
    history.forEach((m) => {
        const n = Number(m.id);
        if (Number.isFinite(n) && n > newestHistoryId) newestHistoryId = n;
    });

    const kept = (current || []).filter((m) => {
        if (historyIds.has(m.id)) return false;
        if (m.status === 'sending') return true;
        const n = Number(m.id);
        return m.id != null && Number.isFinite(n) && n > newestHistoryId;
    });

    return kept.length ? [...history, ...kept].sort(compareById) : history;
}
